<template>
  <div :style="templateType" style="background-size:100%">
    <!--    <img src="./print.svg" alt="" style="width: 100%;">-->

    <div
      :class="
        enterPriseInfo.bannerImg != null &&
        enterPriseInfo.bannerImg != undefined &&
        enterPriseInfo.bannerImg != ''
          ? 'printBanner1'
          : 'printBanner'
      "
    >
      <div
        v-if="
          enterPriseInfo.bannerImg != null &&
            enterPriseInfo.bannerImg != undefined &&
            enterPriseInfo.bannerImg != ''
        "
        :style="{ backgroundImage: 'url(' + enterPriseInfo.bannerImg + ')' }"
      ></div>
      <div v-else></div>
    </div>
    <div class="container">
      <div class="topServBox">
        <el-row :gutter="30">
          <el-col :span="12">
            <div class="mpBox">
              <img
                style="width: 100px; height: 80px; margin-right: 15px"
                :src="enterPriseInfo.storeHeader"
                v-if="
                  enterPriseInfo.storeHeader != null &&
                    enterPriseInfo.storeHeader != '' &&
                    enterPriseInfo.storeHeader != undefined
                "
              />
              <img
                style="width: 80px; height: 80px; margin-right: 15px"
                src="@/assets/image/服务商_画板 1.jpg"
                v-else
              />
              <div class="topServBoxInfo">
                <h3>{{ enterPriseInfo.name }}</h3>
                <p
                  style="width: 38em; overflow: hidden; text-overflow:ellipsis;white-space: nowrap;"
                  :title="content"
                >
                  <span>简介：</span>
                  {{ content }}
                </p>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div
              class="flex"
              style="
                justify-content: space-between;
                align-items: center;
                margin-top: 20px;
              "
            >
              <div style="flex: 1; margin-right: 50px">
                <div class="topServBoxNum">
                  <div>
                    <p>{{ fsCount }}</p>
                    <p>粉丝</p>
                  </div>
                  <div>
                    <p>{{ evaluationCount }}</p>
                    <p>评价</p>
                  </div>
                  <div>
                    <p>{{ orderCount }}</p>
                    <p>订单</p>
                  </div>
                </div>
              </div>
              <div style="flex: 1">
                <div>
                  <el-button
                    type="primary"
                    size="small"
                    v-if="!follow"
                    @click.native="saveFollow"
                    ><i
                      class="iconfont icon-aixin1"
                      style="font-size: 12px;"
                    ></i>
                    关注店铺
                  </el-button>
                  <el-button
                    type="primary"
                    size="small"
                    v-if="follow"
                    @click.native="removeFollow"
                    ><i
                      class="iconfont icon-aixin"
                      style="font-size: 12px;"
                    ></i>
                    取消关注
                  </el-button>
                  <el-button
                    type="primary"
                    size="small"
                    icon="el-icon-chat-dot-square"
                    @click="startChat(userUuid)"
                    >立即联系
                  </el-button>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-menu
          active-text-color="#009999"
          :default-active="printIndex2"
          class="menu-sub"
          mode="horizontal"
        >
          <el-menu-item
            :index="items.title"
            v-for="(items, index) in tabsRight"
            :key="items.title"
            v-show="
              designerType === items.type ||
                items.type === 'ALL' ||
                designerType === 'ALL'
            "
            @click="getContentTabs(items.title)"
            >{{ items.title }}</el-menu-item
          >
        </el-menu>
      </div>
    </div>
    <div class="container">
      <div style="padding-bottom: 30px">
        <el-row :gutter="30">
          <el-col :span="6">
            <div class="leftCont">
              <el-card class="leftCard facilitatorInfo" shadow="never">
                <div slot="header" class="clearfix">
                  <span>服务商信息</span>
                </div>
                <div class="servInfo">
                  <h3>{{ enterPriseInfo.name }}</h3>
                  <ul class="eval">
                    <li>
                      <span>描述相符</span>
                      <el-rate
                        :value="designerStar"
                        disabled
                        :colors="['#da251d', '#da251d', '#da251d']"
                      >
                      </el-rate>
                    </li>
                    <li>
                      <span>服务态度</span>
                      <el-rate
                        :value="designerStar2"
                        disabled
                        text-color="#da251d"
                        :colors="['#da251d', '#da251d', '#da251d']"
                      >
                      </el-rate>
                    </li>
                    <li>
                      <span>专业程度</span>
                      <el-rate
                        :value="designerStar3"
                        disabled
                        text-color="#da251d"
                        :colors="['#da251d', '#da251d', '#da251d']"
                      >
                      </el-rate>
                    </li>
                  </ul>

                  <ul class="contact">
                    <li>
                      <i class="el-icon-location"></i>所在地
                      <p>
                        {{ enterPriseInfo.province }}{{ enterPriseInfo.city
                        }}{{ enterPriseInfo.district
                        }}{{ enterPriseInfo.address }}
                      </p>
                    </li>
                    <li>
                      <i class="el-icon-phone"></i>联系电话
                      <p>{{ enterPriseInfo.tel }}</p>
                    </li>
                  </ul>
                </div>
              </el-card>
              <el-card
                class="leftCard"
                shadow="never"
                v-if="shopPermission === 'BUSINESS'"
              >
                <div slot="header" class="clearfix">
                  <span>热销商品</span>
                </div>
                <div>
                  <ul class="hotSell ">
                    <li
                      v-for="(item, index) in hotShopList1"
                      :key="index"
                      @click="goToDetail(item.uuid)"
                    >
                      <div class="mpBox" style="cursor: pointer;">
                        <img
                          style="width: 64px; height: 64px; margin-right: 15px;flex-shrink: 0;"
                          :src="item.imgUrl"
                        />
                        <div class="topServBoxInfo">
                          <div class="flex brandBox">
                            <p class="brand" v-if="item.brand">
                              {{ item.brand }}
                            </p>
                            <h3>{{ item.name }}</h3>
                          </div>
                          <span
                            style="font-size: 12px;font-weight: bold;color: #ff0000;"
                            >¥{{ item.minPrice }}</span
                          >
                          <p>{{ item.shopName }}</p>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </el-card>
              <el-card class="leftCard" shadow="never">
                <div slot="header" class="clearfix">
                  <span>推荐服务商</span>
                </div>
                <div>
                  <ul class="relateServ">
                    <li
                      v-for="(item, index) in hotProvidersList"
                      :key="index"
                      @click="
                        getPrintServiceIndex(
                          item.enterpriseUuid != undefined
                            ? item.enterpriseUuid
                            : item.enterpriseUuid
                        )
                      "
                    >
                      <div class="mpBox">
                        <img
                          style="width: 64px; height: 64px; margin-right: 15px"
                          :src="item.logo"
                          v-if="
                            item.logo != null &&
                              item.logo != '' &&
                              item.logo != undefined
                          "
                        />
                        <img
                          style="width: 64px; height: 64px; margin-right: 15px"
                          src="@/assets/storeLogo.jpeg"
                          v-else
                        />
                        <div class="topServBoxInfo">
                          <h3>{{ item.name }}</h3>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </el-card>
            </div>
          </el-col>
          <el-col :span="18" v-show="printIndex == '1'">
            <div class="hotMaterial" v-if="providersPermission === 'SELLER'">
              <h2 class="printTitle">
                <span class="tit">需求</span>
                <span class="more" @click="getContentTabs('全部需求')"
                  >查看更多<i class="el-icon-arrow-right"></i
                ></span>
              </h2>
              <AllRequirement
                :showSearch="false"
                :tableList="demandList"
                :total="demandTotal"
                :showPage="false"
                @handleQueryChange="demandQueryChange"
              ></AllRequirement>
            </div>
            <div v-if="providersPermission === 'SELLER'">
              <h2 class="printTitle">
                <span class="tit">服务</span>
                <span class="more" @click="getContentTabs('全部服务')"
                  >查看更多<i class="el-icon-arrow-right"></i
                ></span>
              </h2>
              <div
                v-if="sellerServiceList.length == 0"
                style="text-align:center;margin-bottom:20px"
              >
                <img
                  src="../../assets/暂无内容.jpg"
                  alt=""
                  style="width:200px"
                />
              </div>
              <el-row
                :gutter="30"
                style="display: flex;flex-wrap: wrap"
                v-if="sellerServiceList.length != 0"
              >
                <el-col
                  :span="8"
                  v-for="(items, index) in sellerServiceList"
                  :key="index"
                  @click.native="getServiceDetails(items.id)"
                >
                  <el-card
                    class="box-card"
                    shadow="hover"
                    :body-style="{ padding: '0px' }"
                  >
                    <div class="image" v-if="items.mainPhotoUrl != null">
                      <img
                        style="width: 100%;height: 200px;"
                        :src="items.mainPhotoUrl"
                        alt=""
                      />
                    </div>
                    <div style="padding: 15px">
                      <h4 class="mpTitle">{{ items.title }}</h4>
                      <p class="mpComp" :title="items.enterpriseName">
                        {{ items.enterpriseName }}
                      </p>
                      <dl class="mpDetail clearfix">
                        <dt>服务行业：</dt>
                        <dd>{{ items.oneLabel | ellipsisService }}</dd>
                      </dl>
                      <p class="mpPrice">
                        ¥{{ items.money }}
                        <span>{{
                          items.isBargain == "0" ? "议价" : "不可议"
                        }}</span>
                      </p>
                      <div class="mpFooter">
                        <span>
                          <i
                            class="el-icon-star-off"
                            style="margin-right: 8px"
                          ></i>
                          收藏量：{{ items.collectNum }}
                        </span>
                        <span>
                          <i
                            class="el-icon-shopping-cart-2"
                            style="margin-right: 8px"
                          ></i>
                          交易量：{{ items.orderNum }}
                        </span>
                      </div>
                    </div>
                  </el-card>
                </el-col>
              </el-row>
            </div>
            <div v-if="shopPermission === 'BUSINESS'">
              <h2 class="printTitle">
                <span class="tit">热销商品</span>
                <span class="more" @click="getContentTabs('全部商品')"
                  >查看更多<i class="el-icon-arrow-right"></i
                ></span>
              </h2>
              <div
                v-if="hotShopList.length == 0"
                style="text-align:center;margin-bottom:20px"
              >
                <img
                  src="../../assets/暂无内容.jpg"
                  alt=""
                  style="width:200px"
                />
              </div>
              <el-row
                :gutter="30"
                style="display: flex;flex-wrap:wrap"
                v-if="hotShopList.length > 0"
                class="imgListBox"
              >
                <el-col
                  :span="8"
                  v-for="(items, index) in hotShopList"
                  :key="index"
                  @click.native="goToDetail(items.uuid)"
                >
                  <el-card
                    class="dmessagesBottombox"
                    shadow="hover"
                    :body-style="{ padding: '0px' }"
                  >
                    <img :src="items.imgUrl" alt="" />
                    <div class="sdmessagesbotMes">
                      <div class="flex brandBox">
                        <p class="brand" v-if="items.brand">
                          {{ items.brand }}
                        </p>
                        <h4>{{ items.name }}</h4>
                      </div>
                      <!-- <p>{{ items.shopName }}</p> -->
                      <span
                        style="font-size: 12px;font-weight: bold;color: #ff0000;"
                        >¥{{ items.minPrice }}</span
                      >
                    </div>
                  </el-card>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <PrintShopResults
            v-show="printIndex == '6' && shopPermission === 'BUSINESS'"
            ref="shopMap"
          />
          <TransactionRecords
            v-show="printIndex == '7'"
            style="width: 73%; overflow: hidden;margin-top: 30px;"
            ref="transactionRecordRef"
          />
          <PrintContact v-show="printIndex == '5'" ref="childMap" />
          <ServiceList v-show="printIndex == '8'" ref="shopMap1" />
          <DemandList v-show="printIndex == '9'" ref="shopMap2" />
          <el-col :span="18">
            <CaseList v-show="printIndex == '4'" ref="caseRef"></CaseList>
          </el-col>
          <!-- 全部服务 -->
          <!-- <el-col :span="18">
                        <AllService></AllService>
                    </el-col> -->
          <!-- 全部需求 -->
          <el-col :span="18">
            <!-- <AllRequirement></AllRequirement> -->
          </el-col>
        </el-row>
      </div>
    </div>

    <!--聊天窗口-->
    <chat-dialog ref="chatDialogRef"></chat-dialog>
  </div>
</template>

<script>
import {
  getSellerSettledDetail,
  isFollow,
  getNewcurrent,
  getUserInfo,
  getStoreInfoByEnterPriseUuid,
  getInfoByEnterPriseUuid,
  getShopList,
  findShopSettledInfo,
  findStoreInfoList,
  saveFollow,
  removeFollow,
  getAllEvaluationList,
  getRongCloudUser,
  pageSettingInfo,
  getDemandsByPage,
  serviceEnterprisePage,
  saveVolumeCount,
  getSellerProvidersList,
} from "../../utils/interface"
import TransactionRecords from "../transactionRecords/transactionRecords"
import PrintShopResults from "./printShopResults"
import AllService from "./allService"
import AllRequirement from "./allRequirement"
import PrintContact from "./printContact"
import { mapState, mapMutations } from "vuex"
import chatDialog from "../chat/chatDialog"
import ServiceList from "./serviceList.vue"
import DemandList from "./demandList.vue"
import CaseList from "./caseList.vue"
export default {
  //   服务商首页
  name: "printServiceIndex",
  metaInfo() {
    return {
      title: this.metaTitle,
      meta: [
        {
          // set meta
          name: "keywords",
          content: this.metaKeywords,
        },
        {
          // set meta
          name: "description",
          content: this.metaDescription,
        },
      ],
    }
  },
  components: {
    PrintContact,
    chatDialog,
    PrintShopResults,
    TransactionRecords,
    AllService,
    AllRequirement,
    ServiceList,
    DemandList,
    CaseList,
  },
  data() {
    return {
      form: {},
      evaluationCount: 0,
      designerStar: 0,
      designerStar2: 0,
      designerStar3: 0,
      printIndex: "1",
      pageIndex: "1",
      menuIndex: "1",
      uuid: "",
      storeUuid: "",
      userUuid: "",
      enterPriseInfo: "",
      managerList: [],
      sellerServiceList: [],
      sellerSettled: "",
      content: "",
      follow: false,
      followUuid: "",
      userMessages: {},
      fsCount: 0,
      orderCount: 0,
      hotSortList: [],
      hotProvidersList: [],
      permissionList: [],
      providersPermission: "",
      shopPermission: "",
      hotShopList: [],
      hotShopList1: [],
      shopList: [],
      tabsRight: [],
      designerType: "",
      // templateType:"background: url('../../assets/image/base_one.png')",
      templateType: "background: #F9F9F9;",
      printIndex2: "0",
      metaTitle: "",
      metaKeywords: "",
      metaDescription: "",
      demandTotal: 0,
      demandList: [], //需求列表
      volumeCount: 1,
    }
  },
  computed: {
    ...mapState({
      isTokenDoor: "isTokenDoor",
      isLogin: "isLogin",
      isUsermessage: "isUsermessage",
    }),
  },
  created() {
    this.enterPriseId = this.$route.params.enterPriseId
    this.getPrintEnterPriseInfo()
    this.isFollow()
    this.sellerList()
    // 查询店铺信息区分店铺是服务商还是商家信息
    getStoreInfoByEnterPriseUuid({ enterPriseId: this.enterPriseId }).then(
      (res) => {
        if (res.success) {
          this.storeUuid = res.data.uuid
          this.permissionList = res.data.settledList
          if (this.permissionList.length == 2) {
            // 两种权限都存在
            this.designerType = "ALL"
            this.providersPermission = "SELLER"
            this.shopPermission = "BUSINESS"
            this.tabsRight.push({ title: "首页", type: "ALL" })
            this.tabsRight.push({ title: "全部商品", type: "BUSINESS" })
            // this.tabsRight.push({title: '全部服务',type: 'ALL'});
            this.tabsRight.push({ title: "成交记录", type: "ALL" })
            this.tabsRight.push({ title: "企业简介", type: "ALL" })
            this.tabsRight.push({ title: "全部服务", type: "ALL" })
            this.tabsRight.push({ title: "全部需求", type: "ALL" })
            this.tabsRight.push({ title: "全部案例", type: "SELLER" })
            // 如果两种都存在则查询两种数据
            // 查询服务商信息
            this.getProvidersSettledInfo()
            this.commentList2()
            // 热销商品
            this.getHotShopList()
            // 相关服务商
            this.getShopProvider()
            // 店铺信息
            this.findShopSettledInfo()
            this.printIndex2 = this.tabsRight[0].title
          } else {
            // 只存在一种权限
            if (this.permissionList[0].type === "SELLER") {
              this.designerType = "SELLER"
              this.providersPermission = this.permissionList[0].type
              this.tabsRight.push({ title: "首页", type: "ALL" })
              this.tabsRight.push({ title: "成交记录", type: "ALL" })
              this.tabsRight.push({ title: "企业简介", type: "ALL" })
              this.tabsRight.push({ title: "全部服务", type: "SELLER" })
              this.tabsRight.push({ title: "全部需求", type: "SELLER" })
              this.tabsRight.push({ title: "全部案例", type: "SELLER" })
              this.getProvidersSettledInfo()
              this.commentList()
            } else if (this.permissionList[0].type === "BUSINESS") {
              this.designerType = "BUSINESS"
              this.tabsRight.push({ title: "首页", type: "ALL" })
              this.tabsRight.push({ title: "全部商品", type: "BUSINESS" })
              this.tabsRight.push({ title: "成交记录", type: "ALL" })
              this.tabsRight.push({ title: "企业简介", type: "ALL" })
              this.shopPermission = this.permissionList[0].type
              this.commentList1()
              // 热销商品
              this.getHotShopList()
              // 相关服务商
              this.getShopProvider()
              // 店铺信息
              this.findShopSettledInfo()
            }
            this.printIndex2 = this.tabsRight[0].title
          }
          pageSettingInfo(this.enterPriseId).then((res) => {
            if (res.data != null) {
              if (res.data.templateNo == "two") {
                this.templateType = `background: url(${require("../../assets/image/base_one.png")})`
              }
              if (
                res.data.menuSettingList != null &&
                res.data.menuSettingList.length > 0
              ) {
                this.tabsRight = []
                let that = this
                res.data.menuSettingList.forEach((items, index) => {
                  if (index == 0) {
                    if (items.menuName == "首页") {
                      that.printIndex = "1"
                    } else if (items.menuName == "全部商品") {
                      that.printIndex = "6"
                    } else if (items.menuName == "成交记录") {
                      that.printIndex = "7"
                    } else if (items.menuName == "企业简介") {
                      that.printIndex = "5"
                    } else if (items.menuName == "全部服务") {
                      that.printIndex = "8"
                    } else if (items.menuName == "全部需求") {
                      that.printIndex = "9"
                    } else if (items.menuName == "全部案例") {
                      that.printIndex = "4"
                    }
                  }
                  this.tabsRight.push({
                    title: items.menuName,
                    type: items.type,
                  })
                })
              }
              this.printIndex2 = this.tabsRight[0].title
            }
          })
        }
      }
    )
    // 获取用户信息
    getNewcurrent()
      .then((res) => {
        this.userMessages = res
      })
      .catch((err) => {
        console.log(err)
      })
  },
  filters: {
    ellipsisService(value) {
      if (!value) return ""
      if (value.length > 10) {
        return value.slice(0, 10) + "..."
      }
      return value
    },
  },
  methods: {
    findShopSettledInfo() {
      findShopSettledInfo({ enterPriseId: this.enterPriseId }).then((res) => {
        if (res.success) {
          if (res && res.data) {
            this.orderCount = res.data.orderNum
            this.fsCount = res.data.fsCount
            this.userUuid = res.data.userUuid

            this.saveVolumeCountInfo()
          }
        }
      })
    },
    getHotShopList() {
      let params = {
        current: 1,
        pageSize: 12,
        orderBy: "volume_descend",
        status: "SHELVE",
        storeId: this.storeUuid,
      }
      getShopList(params).then((res) => {
        this.hotShopList = res.list
        for (let i = 0; i < this.hotShopList.length; i++) {
          if (i < 4 || i == 4) {
            this.hotShopList1.push(this.hotShopList[i])
            // console.log( this.hotShopList1)
          }
        }
      })
    },
    getPrintEnterPriseInfo() {
      getInfoByEnterPriseUuid({ enterPriseUuid: this.enterPriseId }).then(
        (res) => {
          if (res.success) {
            this.enterPriseInfo = res.data.enterPriseInfo
            this.metaTitle =
              res.data.enterPriseInfo.name +
              " -宁夏工业企业数字化转型公共服务平台"
            this.metaKeywords = res.data.enterPriseInfo.metaKeywords
            this.metaDescription = res.data.enterPriseInfo.metaDescription
            if (this.enterPriseInfo.content == undefined) {
              this.content = this.enterPriseInfo.description
                .replace(
                  /<\s*\/?\s*[a-zA-z_]([^>]*?["][^"]*["])*[^>"]*>|&nbsp;|\s|[\r\n]*/g,
                  ""
                )
                .replace("<br>", "")
                .replace("&gt;", ">")
                .replace("&lt;", "<")
                .replace("&amp;", "&")
            } else {
              this.content = this.enterPriseInfo.content
                .replace(
                  /<\s*\/?\s*[a-zA-z_]([^>]*?["][^"]*["])*[^>"]*>|&nbsp;|\s|[\r\n]*/g,
                  ""
                )
                .replace("<br>", "")
                .replace("&gt;", ">")
                .replace("&lt;", "<")
                .replace("&amp;", "&")
            }
          }
        }
      )
    },
    getPrintServiceIndex(enterPriseId) {
      let routeData = this.$router.resolve({
        name: "printServiceIndex",
        params: { enterPriseId: enterPriseId },
      })
      window.open(routeData.href, "_blank")
    },
    getServiceDetails(uuid) {
      /*let routeData = this.$router.resolve({
                    name: "serviceDetails",
                    params: { uuid: uuid },
                });*/
      let routeData = this.$router.resolve({
        path: `/serviceDetails`,
        query: { uuid: uuid },
      })
      window.open(routeData.href, "_blank")
    },
    startChat(targetUserId) {
      if (this.isLogin) {
        let user = this.$store.state.isUsermessage
        if (this.userUuid == this.userMessages.uuid) {
          this.$message.error("检测当前联系企业与您处于同一企业，暂不支持联系!")
          return false
        } else {
          getRongCloudUser(targetUserId).then((res) => {
            // console.log('targetUserId-------' + targetUserId);
            // console.log(res);
            this.$refs.chatDialogRef.init(
              user.uuid,
              user.name,
              user.headUrl,
              res.uuid,
              res.name,
              res.headUrl
            )
          })
        }
      } else {
        this.$message({
          type: "success",
          message: "您需要先登录哦！",
        })
        this.$router.push("/login")
      }
    },
    replyMessage() {
      if (this.isLogin) {
        let user = this.$store.state.isUsermessage
        this.$refs.chatDialogRef.initReply(user.uuid, user.name, user.headUrl)
      } else {
        this.$message({
          type: "success",
          message: "您需要先登录哦！",
        })
        this.$router.push("/login")
      }
    },
    ...mapMutations(["isLoginVuex"]),
    getProvidersSettledInfo() {
      let params = {
        enterPriseId: this.enterPriseId,
      }
      getSellerSettledDetail(params).then((res) => {
        this.fsCount = res.data.fsCount

        console.log(res.data.managerList)
        this.sellerSettled = res.data.sellerSettled
        this.orderCount = res.data.orderCount
        this.userUuid = res.data.sellerSettled.userUuid

        this.getDemandsList()
        this.serviceList()
        this.saveVolumeCountInfo()
      })
    },
    isFollow() {
      let params = {
        enterPriseUuid: this.enterPriseId,
        followType: "SELLER",
        // followType: 'SHOP'
      }
      isFollow(params).then((res) => {
        if (res && res.data != null) {
          this.follow = true
          this.followUuid = res.data.uuid
        }
      })
    },
    getContentTabs(name) {
      console.log("tabsRight", this.tabsRight)
      this.printIndex2 = name
      // window.sessionStorage.setItem('menuIndex',num)
      let num
      if (name == "首页") {
        num = "1"
      } else if (name == "全部商品") {
        num = "6"
      } else if (name == "成交记录") {
        num = "7"
      } else if (name == "企业简介") {
        num = "5"
      } else if (name == "全部服务") {
        num = "8"
      } else if (name == "全部需求") {
        num = "9"
      } else if (name == "全部案例") {
        num = "4"
      }
      this.printIndex = num
      if (num == "5") {
        this.$refs.childMap.initMap()
      } else if (num == "6") {
        this.$refs.shopMap.init(this.storeUuid)
        document.documentElement.scrollTop = document.body.scrollTop = 0
      } else if (num == "8") {
        this.$refs.shopMap1.init(this.enterPriseId)
      } else if (num == "9") {
        this.$refs.shopMap2.init(this.userUuid)
      } else if (num == "4") {
        this.$refs.caseRef.init(this.enterPriseId)
      }
      if (num == "2") {
        document.documentElement.scrollTop = document.body.scrollTop = 0
      }
      if (num == "7") {
        this.$refs.transactionRecordRef.init("", "", this.enterPriseId, "")
      }
    },
    backTop() {
      const that = this
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop =
          that.scrollTop + ispeed
        if (that.scrollTop === 0) {
          clearInterval(timer)
        }
      }, 16)
    },

    // 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
    scrollToTop() {
      const that = this
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      that.scrollTop = scrollTop
      if (that.scrollTop > 60) {
        that.btnFlag = true
      } else {
        that.btnFlag = false
      }
    },

    saveFollow() {
      // 如果为当前登录用户的服务则不允许收藏
      // 获取当前用户信息
      if (this.isLogin) {
        if (this.userUuid == this.userMessages.uuid) {
          this.$message.error("无法关注自己的店铺")
          return false
        }
        // 收藏服务
        let params = {
          enterPriseUuid: this.enterPriseId,
          followType: "SELLER",
        }
        saveFollow(params).then((res) => {
          if (res.success) {
            this.follow = !this.follow
            this.$message.success("关注成功!")
            this.followUuid = res.data.uuid
            this.fsCount++
          }
        })
      } else {
        this.$message({
          type: "success",
          message: "您需要先登录哦！",
        })
        this.$router.push("/login")
      }
    },
    removeFollow() {
      // 收藏服务
      let params = {
        uuid: this.followUuid,
      }
      removeFollow(params).then((res) => {
        if (res.success) {
          this.follow = !this.follow
          this.$message.success("取消成功!")
          this.followUuid = ""
          this.fsCount--
        }
      })
    },
    commentList() {
      this.form.sellerUuid = this.$route.params.enterPriseId
      this.form.orderType = "SERVICE"
      this.form.evaluationType = "NORMAL"
      getAllEvaluationList(this.form).then((res) => {
        // console.log(res);
        if (res != null && res.length > 0) {
          let a = 0
          let b = 0
          let c = 0
          res.forEach((item, index) => {
            a += parseInt(item.descriptionPoint)
            b += parseInt(item.servicePoint)
            c += parseInt(item.transportPoint)
          })
          this.evaluationCount = res.length
          this.designerStar = Math.round(a / res.length)
          this.designerStar2 = Math.round(b / res.length)
          this.designerStar3 = Math.round(c / res.length)
        }
      })
    },
    commentList1() {
      this.form.sellerUuid = this.$route.params.enterPriseId
      this.form.orderType = "SHOP"
      this.form.evaluationType = "NORMAL"
      getAllEvaluationList(this.form).then((res) => {
        // console.log(res);
        if (res != null && res.length > 0) {
          let a = 0
          let b = 0
          let c = 0
          res.forEach((item, index) => {
            a += parseInt(item.descriptionPoint)
            b += parseInt(item.servicePoint)
            c += parseInt(item.transportPoint)
          })
          this.evaluationCount = res.length
          this.designerStar = Math.round(a / res.length)
          this.designerStar2 = Math.round(b / res.length)
          this.designerStar3 = Math.round(c / res.length)
        }
      })
    },
    commentList2() {
      this.form.sellerUuid = this.$route.params.enterPriseId
      this.form.orderType = "STORE"
      this.form.evaluationType = "NORMAL"
      getAllEvaluationList(this.form).then((res) => {
        // console.log(res);
        if (res != null && res.length > 0) {
          let a = 0
          let b = 0
          let c = 0
          res.forEach((item, index) => {
            a += parseInt(item.descriptionPoint)
            b += parseInt(item.servicePoint)
            c += parseInt(item.transportPoint)
          })
          this.evaluationCount = res.length
          this.designerStar = Math.round(a / res.length)
          this.designerStar2 = Math.round(b / res.length)
          this.designerStar3 = Math.round(c / res.length)
        }
      })
    },
    goToDetail(uuid) {
      let routeData = this.$router.resolve({
        name: "shopGoodDetails",
        params: { uuid: uuid },
      })
      window.open(routeData.href, "_blank")
    },
    //需求
    demandQueryChange(info) {
      console.log("需求列表查询参数", info)
    },
    getDemandsList() {
      let param = {
        currentPage: 1,
        pageSize: 6,
        creator: this.userUuid,
      }
      getDemandsByPage(param).then((res) => {
        this.demandList = res.data.records
        this.demandTotal = parseInt(res.data.total)
      })
    },
    serviceList() {
      let param = {
        currentPage: 1,
        pageSize: 6,
        enterpriseUuid: this.enterPriseId,
        audit: "1",
      }
      serviceEnterprisePage(param).then((res) => {
        this.sellerServiceList = res.records
      })
    },
    saveVolumeCountInfo() {
      //双重身份的时候只记录一次
      if (this.volumeCount > 1) {
        return false
      }
      this.volumeCount++
      let param = {
        userUuid: this.userUuid,
        volumeType: "PROVIDERS",
      }
      saveVolumeCount(param).then((res) => {
        if (res.success) {
        }
      })
    },
    sellerList() {
      let param = {
        survival: "ENABLE",
        boutique: "1",
        current: 1,
        pageSize: 6,
      }
      getSellerProvidersList(param).then((res) => {
        this.hotProvidersList = res.list
      })
    },
  },
  mounted() {
    this.pageIndex = this.$route.params.pageIndex
    if (this.pageIndex != undefined && this.pageIndex != null) {
      let name
      if (this.pageIndex == "1") {
        name = "首页"
      } else if (this.pageIndex == "2") {
        name = "全部需求"
      } else if (this.pageIndex == "3") {
        name = "全部服务"
      } else if (this.pageIndex == "6") {
        name = "全部商品"
      } else if (this.pageIndex == "4") {
        name = "全部案例"
      } else if (this.pageIndex == "7") {
        name = "成交记录"
      } else if (this.pageIndex == "5") {
        name = "企业简介"
      }
      this.printIndex2 = name
      this.getContentTabs(name)
    }
    window.addEventListener("scroll", this.scrollToTop)
  },

  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop)
  },
}
</script>

<style scoped lang="less">
// .templateType {
//     background: url('../../assets/image/base_one.png');

// }
.hotMaterial {
  /deep/.el-card__body {
    padding-bottom: 14px;
  }
}
.imgListBox {
  /deep/ .el-col-8 {
    width: 25%;
  }
}
.printBanner {
  div {
    height: 300px;
    background: url(../../assets/image/fulist.png) no-repeat center center;
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
}

.printBanner1 {
  div {
    height: 300px;
    background-size: cover;
  }
}

.container {
  width: 1200px;
  margin: 0 auto;
}

.leftCont {
  margin-top: 30px;

  .leftCard {
    margin-bottom: 14px;
    border: none;

    /deep/ .el-card__header {
      color: #009999;
      background-color: #f3f3f3;
      font-size: 16px;
      padding: 12px 20px;
    }
    /deep/ .el-card__body {
      background-color: #fff;
      padding: 20px 15px 15px 15px;
      // height: 452px;
    }
    &.facilitatorInfo {
      /deep/ .el-card__body {
        height: 280px;
      }
    }
  }

  .servInfo h3 {
    font-size: 16px;
    font-weight: normal;
    margin-bottom: 15px;
  }

  .servInfo .eval li {
    font-size: 14px;
    margin-bottom: 10px;
    display: flex;
  }

  .servInfo .eval li span {
    margin-right: 30px;
  }

  .servInfo .contact {
    margin-top: 30px;
    margin-bottom: -10px;
    font-size: 12px;
  }

  .servInfo .contact i {
    margin-right: 5px;
  }

  .servInfo .contact p {
    font-size: 14px;
    margin-bottom: 10px;
  }
}

.printTitle {
  font-size: 16px;
  font-weight: normal;
  color: #009999;
  margin-top: 30px;
  margin-bottom: 30px;
  border-bottom: 1px solid #e3e3e3;
  padding-bottom: 10px;

  span.tit {
    padding-bottom: 10px;
    border-bottom: 1px solid #009999;
  }

  span.more {
    font-size: 13px;
    float: right;
    margin-top: 10px;
    cursor: pointer;
    &:hover {
      color: #009999;
    }
  }
}

.hotSell {
  margin-bottom: -30px;

  li {
    margin-bottom: 30px;
  }
  .topServBoxInfo {
    .brandBox {
      align-items: center;
      width: 210px;
    }
  }
  .topServBoxInfo h3 {
    font-size: 14px;
    font-weight: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 130px;
  }

  .topServBoxInfo p {
    font-size: 12px;
    color: #aaa;
    word-wrap: break-word;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // white-space: nowrap;
    // width: 160px;
  }
}

.relateServ {
  margin-bottom: -30px;

  li {
    margin-bottom: 30px;
    cursor: pointer;
  }

  .topServBoxInfo h3 {
    font-size: 14px;
    margin-bottom: 6px;
    font-weight: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 160px;
  }
}

.topServBox {
  background-color: #fff;
  height: 200px;
  border-radius: 8px;
  box-shadow: 0 1px 5px #eaeaea;
  margin-top: -100px;
  padding: 30px;
  box-sizing: border-box;

  .topServBoxInfo h3 {
    font-size: 16px;
    margin-bottom: 6px;
    font-weight: normal;
  }

  .topServBoxInfo p {
    font-size: 12px;
    color: #585858;
  }

  /deep/ .el-menu.el-menu--horizontal {
    border-color: transparent;
  }

  /deep/ .el-menu--horizontal > .el-menu-item.is-active {
    border: none !important;
    border-bottom-color: transparent !important;
    background-color: #f3f8ff;
    border-radius: 5px;
  }

  /deep/ .el-menu--horizontal > .el-menu-item {
    height: 30px;
    line-height: 26px;
  }
}

.topServBoxNum {
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;

  p:first-child {
    font-size: 16px;
  }

  p:last-child {
    font-size: 12px;
    color: #585858;
  }
}

.menu-sub {
  margin-top: 35px;
  font-size: 16px;
}

.box-card {
  margin-bottom: 30px;
  /*height: 400px;*/
  position: relative;
  .image {
    width: 100%;
    height: 200px;
    display: block;
  }
  /deep/.el-card__body {
    padding: 20px 10px 15px 15px;
  }
}

.mpBox {
  display: flex;
  align-items: center;
}

.mpCheck {
  position: absolute;
  right: 20px;
  top: 20px;
}

.mpTitle {
  font-size: 16px;
  font-weight: normal;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mpComp {
  margin-top: 10px;
  font-size: 13px;
  color: #000000;
}

.mpPrice {
  margin: 10px 0;
  font-size: 13px;
  color: #da251d;

  span {
    color: #000;
    margin-left: 10px;
  }
}

.mpDetail {
  margin-top: 10px;

  dt {
    float: left;
    width: 70px;
    color: #000;
    font-size: 13px;
    font-weight: normal;
    line-height: 22px !important;
  }

  dd {
    font-size: 13px;
    line-height: 22px !important;
    margin-left: 70px;
    margin-bottom: 6px;
    color: #808080;
  }
}

.mpFooter-v1 {
  text-align: center;
  font-size: 14px;
  background: #f1f5fe;
  border: 1px solid #ebeef5;
  margin: -10px -21px -21px;
  height: 50px;
  line-height: 50px;
}

.mpFooter {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  border-top: 1px solid #e3e3e3;
  margin: 0 0 -15px;
  position: relative;

  span {
    display: inline-block;
    width: 50%;
    text-align: center;
    font-size: 13px;
    height: 50px;
    line-height: 50px;
  }

  span a {
    font-size: 12px;
    color: #808080;
  }

  span a:hover {
    color: rgba(21, 126, 251, 0.8);
  }

  :after {
    position: absolute;
    content: "";
    width: 1px;
    background-color: #e3e3e3;
    height: 34px;
    top: 8px;
    left: 50%;
  }
}

.printBox {
  /deep/ .el-input--suffix .el-input__inner {
    padding: 0 15px;
  }
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

a {
  color: #009999;
}

a:hover {
  color: rgba(21, 126, 251, 0.8);
}

.dmessagesBottombox {
  width: 216px;
  // margin-bottom: 25px;
  margin-bottom: 13px;

  img {
    width: 100%;
    height: 138px;
    background: #efefef;
    display: block;
  }

  .sdmessagesbotMes {
    cursor: pointer;
    width: 100%;
    height: 62px;
    color: #0f1826;
    text-align: center;
    background: #f5f5f5;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .brandBox {
      width: 216px;
      align-items: center;
      justify-content: center;
    }
    h4 {
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    p {
      font-size: 10px;
      font-weight: 400;
    }

    span {
      font-size: 12px;
      font-weight: bold;
      color: #ff0000;
    }
  }
  .sdmessagesbotMes:hover {
    background: #79cdcd !important;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/print/printServiceIndex.vue